import InvokeAnalysisProduct from "./InvokeAnalysisProduct";

function InvokeEnrollment(props) {

    return(<InvokeAnalysisProduct product="InvokeEnrollment" />);
}

export default InvokeEnrollment;